/** The footer every claim-action dialog shares: set apart from the body, with room under the buttons. */
export const DIALOG_FOOTER_CLASS_NAME = 'border-0 border-t border-solid border-slate-300 px-24 py-16';

/**
 * The longest note a handler can write to Clive: the reason they turn an action or a request down
 * with, or an answer to a question in their own words.
 */
export const HANDLER_NOTE_MAX_LENGTH = 5000;

/** The rows a handler's note grows to before it scrolls inside its box, so the box stays on screen. */
export const HANDLER_NOTE_MAX_ROWS = 8;
